// @ts-strict-ignore
import { takeEvery } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'

import * as actions from 'mytours-read-common'
import {
	COLLECTION_ITEM_SUBTYPE_TOUR,
	COLLECTION_ITEM_SUBTYPE_LIST,
	COLLECTION_ITEM_SUBTYPE_STORY,
	COLLECTION_ITEM_SUBTYPE_WEB,
	COLLECTION_ITEM_SUBTYPE_MENU,
	COLLECTION_ITEM_SUBTYPE_PANORAMA,
	CollectionListNavigationParams,
	ScreenNavigationParams,
} from 'mytours-read-common'
import { GetCollectionItemsIndexResponseData } from 'mytours-read-api-typescript'

import NavigationService from './NavigationService'
import { CollectionItemsNavigationParams } from '../collection/types'

/**
 * Navigate to the collection screen.
 * @param action contains the collection id to view
 */
function* handleNavigateToCollection(action: actions.CollectionListNavigationAction): SagaIterator {
	const { item } = action.payload
	const subtype: GetCollectionItemsIndexResponseData.ItemSubtypeEnum = [
		COLLECTION_ITEM_SUBTYPE_TOUR,
		COLLECTION_ITEM_SUBTYPE_LIST,
		COLLECTION_ITEM_SUBTYPE_MENU,
	].includes(item.item_subtype)
		? item.item_subtype
		: undefined

	if (subtype === undefined) {
		throw Error('Unsupported collection subtype: ' + item.item_subtype)
	}

	const params: CollectionListNavigationParams = {
		// forcing existance of params!
		collectionId: item.item_id,
		collectionTitle: item.title,
		collectionVersion: item.version,
		isTopCollection: false,
	}

	if (subtype === COLLECTION_ITEM_SUBTYPE_TOUR) {
		NavigationService.navigateToTourDetails(params)
	} else if (subtype === COLLECTION_ITEM_SUBTYPE_LIST) {
		NavigationService.navigateToCollectionList(params)
	} else if (subtype === COLLECTION_ITEM_SUBTYPE_MENU) {
		NavigationService.navigateToMenu(params)
	}
}

/**
 * Navigate to the Screen screen.
 * @param action contains the collection item id to view
 */
function* handleNavigateToScreen(action: actions.ScreenNavigationAction): SagaIterator {
	const { item, parentItemId } = action.payload
	const subtype = [
		COLLECTION_ITEM_SUBTYPE_STORY,
		COLLECTION_ITEM_SUBTYPE_WEB,
		COLLECTION_ITEM_SUBTYPE_PANORAMA,
	].includes(item.item_subtype)
		? item.item_subtype
		: undefined

	if (subtype === undefined) {
		throw Error('Unsupported screen subtype: ' + item.item_subtype)
	}

	const params: ScreenNavigationParams = {
		// forcing existence of params!
		itemId: item.item_id,
		title: item.title,
		itemVersion: item.version,
	}

	switch (subtype) {
		case COLLECTION_ITEM_SUBTYPE_STORY:
			return NavigationService.navigateToScreenStory(params, parentItemId)
		case COLLECTION_ITEM_SUBTYPE_PANORAMA:
			return NavigationService.navigateToScreenPanorama(params, parentItemId)
		case COLLECTION_ITEM_SUBTYPE_WEB:
			return NavigationService.navigateToScreenWeb(params, parentItemId)
	}
}

function* handleNavigateToTourStops(action: actions.NavigateToTourStopsAction): SagaIterator {
	const params: CollectionItemsNavigationParams = {
		collectionId: action.payload.tourId,
		collectionVersion: action.payload.tourVersion,
		accountId: action.payload.accountId,
		collectionTitle: action.payload.tourTitle,
		// if we are just starting the tour (not navigating to a specifc stop) we set the title to empty string - in the TourStops component we set the initial title in the constructor
		title: action.payload.tourStopTitle ? action.payload.tourStopTitle : action.payload.tourTitle,
	}
	NavigationService.navigateToCollectionItems({
		params,
		collectionType: GetCollectionItemsIndexResponseData.ItemSubtypeEnum.Tour,
		itemType: 'item',
	})
}

export default function* (): SagaIterator {
	yield takeEvery(actions.navigateToCollection, handleNavigateToCollection)
	yield takeEvery(actions.navigateToScreen, handleNavigateToScreen)
	yield takeEvery(actions.navigateToTourStops, handleNavigateToTourStops)
}
